import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { practiceApi, errorMessage } from './api'
import { PRACTICE_PATH, LANGUAGE_LABELS, preferredLanguage, rememberLanguage, StatusBadge, WorkedExample } from './practiceShared'
import './stDiagnostic.css'

// Practice home: the patterns of the chosen level, each with its idea, a worked example
// and its problems with the learner's status.
export default function StPractice() {
  const [state, setState] = useState('loading')
  const [error, setError] = useState('')
  const [data, setData] = useState(null)
  const [level, setLevel] = useState(() => { try { return localStorage.getItem('stPracticeLevel') || 'basic' } catch { return 'basic' } })
  const [language, setLanguage] = useState(preferredLanguage)
  const [openExample, setOpenExample] = useState(null)

  useEffect(() => {
    practiceApi.get('/problems')
      .then(({ data }) => { setData(data); setState('ready') })
      .catch(err => {
        if (err?.response?.status === 401) setState('login')
        else { setError(errorMessage(err)); setState('error') }
      })
  }, [])

  const chooseLevel = (l) => {
    setLevel(l)
    try { localStorage.setItem('stPracticeLevel', l) } catch { /* not important */ }
  }
  const chooseLanguage = (l) => { setLanguage(l); rememberLanguage(l) }

  if (state === 'loading') return <div className="std"><div className="std-wrap">Loading…</div></div>
  if (state === 'login') {
    return (
      <div className="std"><div className="std-wrap"><div className="std-card">
        <h2>Please sign in</h2>
        <p>Sign in to practise writing programs and keep your progress.</p>
        <Link className="std-btn" to="/login">Sign in</Link>
      </div></div></div>
    )
  }
  if (state === 'error') return <div className="std"><div className="std-wrap"><div className="std-alert std-alert-bad">{error}</div></div></div>

  const { patterns, summary } = data
  const shown = patterns.filter(p => p.level === level)

  return (
    <div className="std">
      <div className="std-wrap">
        <h1>Writing a program — practice</h1>
        <p className="std-muted">
          For every problem: first write your plan in plain English, then code it, then submit. Hints unlock after a few tries;
          a model solution appears once you solve it.
        </p>

        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', margin: '12px 0' }}>
          <span className="std-badge">Basic: {summary.basic.solved}/{summary.basic.total} solved</span>
          <span className="std-badge">Tough: {summary.tough.solved}/{summary.tough.total} solved</span>
          <span className="std-badge std-badge-ok">Solved on your own: {summary.solvedOnOwn}</span>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10, marginBottom: 12 }}>
          <div className="std-tabs" style={{ marginTop: 0 }}>
            <button className={`std-tab ${level === 'basic' ? 'std-tab-active' : ''}`} onClick={() => chooseLevel('basic')}>Basic (12)</button>
            <button className={`std-tab ${level === 'tough' ? 'std-tab-active' : ''}`} onClick={() => chooseLevel('tough')}>Tough (12)</button>
          </div>
          <label className="std-small" style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
            Language
            <select value={language} onChange={e => chooseLanguage(e.target.value)} style={{ width: 'auto' }}>
              {Object.entries(LANGUAGE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </label>
        </div>

        {shown.map((pattern, index) => (
          <div key={pattern.id} className="std-card">
            <h2 style={{ marginBottom: 4 }}>{index + 1}. {pattern.title}</h2>
            <p style={{ margin: '0 0 8px' }}>{pattern.idea}</p>
            <button className="std-btn std-btn-ghost std-btn-sm" onClick={() => setOpenExample(openExample === pattern.id ? null : pattern.id)}>
              {openExample === pattern.id ? 'Hide worked example' : 'See a worked example'}
            </button>
            {openExample === pattern.id && <div style={{ marginTop: 10 }}><WorkedExample example={pattern.example} language={language} /></div>}

            <table className="std-table" style={{ marginTop: 12 }}>
              <tbody>
                {pattern.problems.map(pr => (
                  <tr key={pr.id}>
                    <td><Link to={`${PRACTICE_PATH}/${pr.id}`}><strong>{pr.title}</strong></Link></td>
                    <td style={{ width: 200 }}><StatusBadge status={pr.status} /></td>
                    <td className="std-muted std-small" style={{ width: 120 }}>{pr.submissions ? `${pr.submissions} submission(s)` : ''}</td>
                    <td style={{ width: 90, textAlign: 'right' }}><Link className="std-btn std-btn-sm" to={`${PRACTICE_PATH}/${pr.id}`}>Open</Link></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  )
}
